import type { compileAiComponent } from '@Pages/pageRuntime/compiler/compileAiComponent';

type PageCompiler = typeof compileAiComponent;

let registeredCompiler: PageCompiler | null = null;

/**
 * Registers the factory compiler of published page source. Only
 * `pageRuntime/sourceRuntime.ts` calls this, so a document that renders
 * prebuilt modules never loads the compiler.
 */
export function registerPageCompiler(compiler: PageCompiler): void {
  registeredCompiler = compiler;
}

/** The registered factory compiler. A document without it never has page source to compile. */
export function pageCompiler(): PageCompiler {
  if (registeredCompiler === null) {
    throw new Error(
      'The page compiler is not registered. Import pageRuntime/sourceRuntime.ts in the surface that renders page source.'
    );
  }

  return registeredCompiler;
}
